import Nav from '../Nav/Nav';
import './SamsungStore.css';
import Footer from '../Footer/Footer';
import SamsungGalaxyList from './SamsungGalaxyList';
// import GalaxyZ, from '../../assets/samsungStore/galaxyz.png';
// import GalaxyA from '../../assets/samsungStore/galaxyA.png';
// import GalaxyM from '../../assets/samsungStore/galaxyM.png';
// import GalaxyF from '../../assets/samsungStore/galaxyF.png';
import S26Carousel from './S26Carousel';
// import SamsungBannerMain from './SamsungBannerMain';
// import SamsungDeals from "./SamsungDeals";

import s1 from '../../assets/samsung/s1.jpg';
// import flip1 from '../../assets/samsung/flip1.jpg';
// import fold1 from '../../assets/samsung/fold1.jpg';
import a1 from '../../assets/samsung/a1.jpg';
// import tab_s10_plus_moonstone_grey from '../../assets/samsung/mix/tab_s10_plus_moonstone_grey.jpeg';
import F1 from '../../assets/samsung/F1Main.png';
import zFold7Main from '../../assets/samsungStore/carouselImages/carousal0/zFold7series/zFold7Main.png';
import tab from '../../assets/samsung/tabdual.jpg';
import ProductSwipper from './reusable/ProductSwipper';
import {
  promoSlides1,
  promoSlides2,
  promoSlides3,
  flipSeries
} from '../../components/SamsungStore/ProductSwipperConstants';

export const samsungGalaxcityData = [
  {
    id: 1,
    model: 'Galaxy S',
    type: 'galaxySSeries',
    image: s1,
    title: 'Galaxy S',
  },
  {
    id: 2,
    model: 'Galaxy A',
    type: 'galaxyASeries',
    image: a1,
    title: 'Galaxy A',
  },
  {
    id: 3,
    model: 'Galaxy F',
    type: 'galaxyFSeries',
    image: F1,
    title: 'Galaxy F',
  },
  {
    id: 4,
    model: 'Galaxy Z',
    type: 'galaxyZSeries',
    image: zFold7Main,
    title: 'Galaxy Z',
  },
  {
    id: 5,
    model: 'Galaxy Tab',
    type: 'galaxyTab',
    image: tab,
    title: 'Galaxy Tab',
  },
];

const SamsungStore = () => {
  return (
    <>
      <Nav />
      <div className="samsung-store-wrapper">
        <section className="samsung-store">
          <SamsungGalaxyList />
        </section>

        <section id="samsung-banner" className="mt-5">
          <S26Carousel />
        </section>
        <section id="samsung-product-slides" className="samsung-product-slides">
          <ProductSwipper slides={flipSeries} productType="Zfold" />
        </section>
        {/* <section id="samsung-deals" className="mt-5">
          <SamsungDeals />
        </section> */}
        <section id="samsung-banner" className="mt-5">
          <ProductSwipper slides={promoSlides1} productType="GalaxyA" />
        </section>
        {/* <section id="samsung-banner-main" className="samsung-product-slides">
          <SamsungBannerMain />
        </section> */}
        <section id="samsung-product-slides" className="samsung-product-slides">
          <ProductSwipper slides={promoSlides2} productType="GalaxyF" />
        </section>
        <section id="samsung-product-slides" className="samsung-product-slides">
          <ProductSwipper slides={promoSlides3} productType="Tabs" />
        </section>
      </div>
      <Footer />
    </>
  );
};

export default SamsungStore;
